import { useOnScreen } from "@/components/home/transitionUtils";
import { NOOP_FN } from "@/constants/stable-empty";
import createAsciiSketch, { SketchUserConfig } from "@/p5/sketch";
import { cx } from "@/utils/classnames";
import dynamic from "next/dynamic";
import React, { useEffect, useMemo, useState } from "react";

const DynamicP5Canvas = dynamic(
  async () => (await import("@/components/code/animated/P5Canvas")).P5Canvas,
  {
    loading: () => null,
    ssr: false,
  },
);

export interface SketchLoaderProps {
  id: string;
  className?: string;
  config?: Omit<SketchUserConfig, "parentId">;
}

export const SketchLoader: React.FC<SketchLoaderProps> = ({ id, className, config }) => {
  const [showAnim, setShowAnim] = useState(false);
  const [onScreen, onScreenRef] = useOnScreen<HTMLDivElement>();

  const [sketch, setPaused] = useMemo(() => {
    try {
      return createAsciiSketch(
        {
          ...config,
          parentId: `${id}-sketch-container`,
        },
        () => setShowAnim(true),
      );
    } catch (e) {
      console.error(e);
      return [undefined, NOOP_FN];
    }
  }, [id, config]);

  useEffect(() => {
    if (onScreen) {
      setPaused(false);
    } else {
      setPaused(true);
    }
  }, [onScreen, setPaused]);
  return (
    <div
      className={cx(
        className,
        "transition-opacity duration-[2s] ease-in-out",
        showAnim ? "opacity-70 sm:opacity-100" : "opacity-0 sm:opacity-0",
      )}
      ref={onScreenRef}
      id={`${id}-sketch-container`}
    >
      {sketch != null && <DynamicP5Canvas sketch={sketch} />}
      <div id={"p5_loading"} style={{ display: "none" }} />
    </div>
  );
};
